import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import matcha from './pictures/matcha.jpeg';
import mm2 from './pictures/MM2.jpeg';
import slides from './pictures/MM2slides.jpeg';

const AuMM2 = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Member Meeting 2 with COM<sup>2</sup>: Matcha & Mentorship</h2>
                    <p class="site-post-meta">October 24, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

                    Thank you to everyone who joined us for our event in collaboration with COM<sup>2</sup>! We had a wonderful time hearing from our amazing panelists about their experiences with recruiting at internships. We also got to enjoy some delicious matcha together!

                    <br></br>
                    <br></br>
                    We loved learning from our panelists about their unique experiences with the recruiting process at various companies, including Pinterest, Amazon, Oracle, and GoDaddy. Each of them shared their personal journeys that got them to where they are today. 
                    This process definitely helped individuals feel more prepared and confident going into their own recruiting processes for internships and ask any questions that they had from individuals who were in the same shoes as they were!
                    <br></br>
                    <br></br>
                    We're so grateful to our panelists, Katherine, Emma, Akshaya, and Ioli, for speaking with us, sharing their experiences, and offering advice. It was a great chance to ask questions, learn about the process at these companies, and even learn about their experience working/interning at these companies.
                    </p>
                    <img src={mm2} alt="Attendees posing after the completion of the event."/>
                    <img src={matcha} alt="Matcha that was provided."/>
                    <img src={slides} alt="Slides at the beginning of the event"/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default AuMM2;
